if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.onClickRefreshList = this.onClickRefreshList.bind(this);

      const currentVariantId = this.getCurrentVariantId();
      if (currentVariantId) {
        this.dataset.variantId = currentVariantId;
        this.fetchAvailability(currentVariantId);
      }
    }

    getCurrentVariantId() {
      const variantInput = document.querySelector('input[name="id"]');
      return variantInput ? variantInput.value : null;
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      console.log('start');
      console.log(rootUrl);
      console.log('variantId');
      console.log(variantId);

      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      const variantId = this.getCurrentVariantId();
      if (variantId) {
        this.dataset.variantId = variantId;
        this.fetchAvailability(variantId);
      }
    }

    renderError() {
      this.innerHTML = '';
      const button = this.querySelector('button');
      if (button) button.addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();

      if (!sectionInnerHTML.querySelector('.pickup-availability-information')) {
        this.innerHTML = '';
        var item_product_title = $('.product-title-container h1').html();
        var item_product_color = $('.variations .product-form__input--siblings label.active a').attr('title');
        var item_product_size = $('.variations .product-form__input--block input[type=radio]:checked+label span').html();
        $('.item_product_title').html(item_product_title);
        $('.item_product_color').html(item_product_color);
        $('.item_product_size').html(item_product_size);
        $('.unavailable_pickup.custom_pickup_text').removeClass('custom_pickup_text');

        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-information').innerHTML;
      var item_product_title = $('.product-title-container h1').html();
      var item_product_color = $('.variations .product-form__input--siblings label.active a').attr('title');
      var item_product_size = $('.variations .product-form__input--block input[type=radio]:checked+label span').html();
      $('.item_product_title').html(item_product_title);
      $('.item_product_color').html(item_product_color);
      $('.item_product_size').html(item_product_size);
      $('.unavailable_pickup.custom_pickup_text').removeClass('custom_pickup_text');

      this.setAttribute('available', '');

      document.getElementById('Pickup-Availability').innerHTML = sectionInnerHTML.querySelector('.side-availability').innerHTML;

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.getElementById('Pickup-Availability').classList.toggle("active");
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        evt.preventDefault();
      });
    }
  });
}
